import { Injectable } from "@angular/core";
import { SearchableComponent, SessionService } from "@edl-development/edl-common";
import { Transition } from "@uirouter/core";
import { firstValueFrom } from "rxjs";
import { UserArchivedFilter } from "src/app/enums/user-request/user-archived-filter.enum";
import { AccessRoleHelper } from "src/app/model/helpers/access-role.helper";
import { UserRequestService } from "src/app/services/user-request.service";

@Injectable()
export class RequestsResolver {

    constructor() { }

    public resolveUserRequestsForItem(
      transition: Transition,
      userRequestService: UserRequestService,
      sessionService: SessionService,
      overridePage?: number,
      overrideLimit?: number
    ) {
      const params = transition.params();
      const currentPage = overridePage ?? params.page ?? 1;
      const limit = overrideLimit ?? sessionService.pageSize();
      const searchBy: string = params.searchBy ? SearchableComponent.UnPackageSearchParameter(params.searchBy) : null;
      const status: number = params.statusId ? params.statusId :-1;
      const act48Status = params.act48Status;
      const approverUserId = params.approverUserId;
      const groupIds: string[] = params.groupIds ?? [];
      const userArchivedFilter: UserArchivedFilter = params.userArchivedFilter != null ? Number(params.userArchivedFilter) : UserArchivedFilter.Active;

      // Check user role and use appropriate endpoint
      const user = sessionService.user;
      const isBasicUser = AccessRoleHelper.isUser(user.AccessRoleID) && !AccessRoleHelper.isLimitedSupervisor(user.AccessRoleID);

      if (isBasicUser) {
        return firstValueFrom(userRequestService
          .getUserRequestsForItemBasicUser({ requestId: params.requestId.toString(), offset: (currentPage - 1) * limit, limit, status, searchBy, act48Status, approverUserId, groupIds, userArchivedFilter })
        )
      } else {
        return firstValueFrom(userRequestService
          .getUserRequestsForItem({ requestId: params.requestId.toString(), offset: (currentPage - 1) * limit, limit, status, searchBy, act48Status, approverUserId, groupIds, userArchivedFilter })
        )
      }
    }
    
}